<template>
    <div>
        <tile-question-layout :panel_required="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :show_help_text="show_help_text" :help_text="help_text" :fabricator="fabricator">

        </tile-question-layout>
    </div>
</template>

<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            compSlab: {
                required: true,
            },
            title: {
                default(){
                    return 'Select Side Panel Composite Glass';
                }
            },
            laminatedGlass: {
                required: true,
            },
            help_text: {
                default(){
                    return 'Laminated glass holds together when shattered. Toughened Glass breaks into small blunt pieces when shattered.';
                }
            },
            show_help_text: {
                default(){
                    return false;
                }
            },
        },
        computed: {
            valid_selection(){
                if (!this.options_loaded) {
                    return false;
                }

                return this.filtered_option_list.find(y => {
                        return y.value == this.localTarget;
                    }) !== undefined;
            },
            passed_filter(){
                return this.variable_ready(this.compSlab);
            },
            thumbURL(){
                return '/thumb/compglass/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/comp-glass?slab=' + this.compSlab + '&laminated=' + this.laminatedGlass;
            },
            cache_key(){
                return '_' + this.compSlab + '_' + this.laminatedGlass;
            },
            panel_required(){
                return this.filtered_option_list.length > 0;
            }
        },
        methods: {
            select_first(){
                if ((this.filtered_option_list.length === 0)) {
                    this.localTarget = undefined;
                    return;
                }

                var new_value = this.filtered_option_list[0];

                this.localTarget = new_value.value;
            },
        },
        watch: {
            'compSlab': function (val, oldVal) {
                this.update_options();
            },
            'laminatedGlass': function (val, oldVal) {
                this.update_options();
            }
        }
    }
</script>
